export const formControl = {
    styleOverrides: {
        root: {
            // width: "100%",
        }
    }
}